<template>
  <div>

  </div>
</template>
<script>
export default {
  name: 'awards',
}
</script>
<style scoped>
img {
  width: 265px;
}
</style>
